import React from 'react';
import {connect} from "react-redux";
import PropTypes from "prop-types";
import {injectIntl} from "react-intl";

import {featureInterface} from "./featureInterface";
import TextInput from "../../Generic/textInput";
import {fixFeatureNumberValueForInput, getFeatureEditPermission} from "../featuresFunctions";
import {featuresSetupUpdateFeature} from "../featuresActions";
import FeaturesSetupFeatureContentShippingTimeSelect from "./FeaturesSetupFeatureContentShippingTimeSelect";
import {MARK_UP_APPLY_TO_TYPES} from "../FeaturesSetupMarkPopup/markUpItemInterface";
import FeaturesSetupFeatureContentMarkUpButton from "./FeaturesSetupFeatureContentMarkUpButton";


const FeaturesSetupFeatureContentCostAndShipping = (props) => {

  const {feature, intl, canEdit, featuresSetupUpdateFeature} = props;

  const featureContentInputChange = (property, value) => {
    if (!canEdit) {
      return false
    }
    if (property === "shippingCost" && feature.priceLocked) {
      return false
    }
    featuresSetupUpdateFeature(feature, property, value)
  }

  const shippingCostValue = fixFeatureNumberValueForInput(feature, "shippingCost");
  const productWeightValue = fixFeatureNumberValueForInput(feature, "productWeight");

  return (
    <div className="fs-feature__content fs-feature__content--without-right-side">
      <div className="fs-feature__line">
        <div className="fs-feature__line-item">
          <TextInput className={"ui-input ui-input--gray4 ui-input--gray4--small text-left" + (canEdit ? "" : " ui-input--gray4--disabled")}
                     placeholder={intl.formatMessage({id: "features.setup.feature.placeholder.shippingName"})}
                     readonly={!canEdit}
                     onChange={(value) => featureContentInputChange("shippingName", value)}
                     value={feature.shippingName || ""}/>
        </div>
        <div className="fs-feature__line-item">
          <TextInput className={"ui-input ui-input--gray4 ui-input--gray4--small text-left" + (canEdit ? "" : " ui-input--gray4--disabled")}
                     placeholder={intl.formatMessage({id: "features.setup.feature.placeholder.shippingCost"})}
                     readonly={!canEdit}
                     numberInput={true}
                     onChange={(value) => featureContentInputChange("shippingCost", value)}
                     value={shippingCostValue}/>
          <FeaturesSetupFeatureContentMarkUpButton feature={feature}
                                                   applyToProps={[MARK_UP_APPLY_TO_TYPES.shippingCost]}/>
        </div>
        <div className="fs-feature__line-item">
          <FeaturesSetupFeatureContentShippingTimeSelect feature={feature}/>
        </div>
      </div>
      <div className="fs-feature__line">
        {["width", "height", "depth"].map(dimension => {
          const inputValue = fixFeatureNumberValueForInput(feature, dimension);
          return (
            <div className="fs-feature__line-item" key={dimension}>
              <TextInput className={"ui-input ui-input--gray4 ui-input--gray4--small text-left"}
                         placeholder={intl.formatMessage({id: "features.setup.feature.placeholder." + dimension})}
                         onChange={(value) => featureContentInputChange(dimension, value)}
                         maxLength={10}
                         numberInput={true}
                         value={inputValue}/>
            </div>
          )
        })}
      </div>
      <div className="fs-feature__line">
        <div className="fs-feature__line-item fs-feature__line-item--price">
          <TextInput className={"ui-input ui-input--gray4 ui-input--gray4--small text-left"}
                     placeholder={intl.formatMessage({id: "features.setup.feature.placeholder.productWeight"})}
                     onChange={(value) => featureContentInputChange("productWeight", value)}
                     maxLength={10}
                     numberInput={true}
                     value={productWeightValue}/>
        </div>
      </div>
    </div>
  )
};

FeaturesSetupFeatureContentCostAndShipping.propTypes = {
  feature: PropTypes.shape(featureInterface).isRequired
}

const mapStateToProps = (store) => {
  const {canEdit} = getFeatureEditPermission(store);

  return {
    canEdit,
  };
};

const mapDispatchToProps = {
  featuresSetupUpdateFeature,
};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(FeaturesSetupFeatureContentCostAndShipping)
)
